import { useState } from "react";
import { Dialog } from "@headlessui/react";

interface CarrierPackageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: (doNotShowAgain: boolean) => void;
}

const CarrierPackageModal = ({
  isOpen,
  onClose,
  onContinue,
}: CarrierPackageModalProps) => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-black/45 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-150 rounded-2xl bg-white md:p-8 p-5 shadow-xl">
          <Dialog.Title className="md:text-2xl text-xl font-semibold text-gray-950">
            Carrier Package Required
          </Dialog.Title>

          <p className="mt-3 text-sm md:text-base font-normal text-gray-500">
            This option uses a specific package provided by the carrier. Your
            item must be shipped in the selected carrier-provided package.
          </p>

          <div className="mt-8 flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
            <label className="flex w-fit cursor-pointer select-none items-center gap-2 text-sm md:text-base text-gray-500">
              <input
                type="checkbox"
                checked={doNotShowAgain}
                onChange={(e) => setDoNotShowAgain(e.target.checked)}
                className="size-5 cursor-pointer accent-blue-600"
              />
              Do not show again
            </label>

            <div className="flex md:gap-4 gap-3">
              <button
                type="button"
                onClick={onClose}
                className="h-13 w-full md:w-auto md:px-6 rounded-xl text-base font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 cursor-pointer transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => onContinue(doNotShowAgain)}
                className="h-13 w-full md:w-auto md:px-6 rounded-xl text-base font-medium text-white bg-blue-600 hover:bg-blue-700 cursor-pointer transition-colors"
              >
                Continue
              </button>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default CarrierPackageModal;
